import React, { FC } from 'react';

import { ResponsiveCarouselWrapper } from 'components/responsive-carousel';
import { RewardsCarousel } from 'components/rewards-carousel';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';

import { IRewardsSectionViewProps } from './types';

export const RewardsSectionView: FC<React.PropsWithChildren<IRewardsSectionViewProps>> = ({
  rewards,
}) => {
  const header = t('rewards');
  const rewardsText = t('viewAll');
  const rewardsAccessibilityLabel = t('viewAllRewards');
  return (
    <ResponsiveCarouselWrapper
      mt="$4"
      header={header}
      linkText={rewardsText}
      linkPath={routes.rewards}
      linkAccessibilityLabel={rewardsAccessibilityLabel}
    >
      <RewardsCarousel rewards={rewards} />
    </ResponsiveCarouselWrapper>
  );
};
